import { FDroidButton } from 'components/DownloadButtons';
import { DownloadURL } from "constants/download";
import * as React from 'react';
export default {
  FDroidButton,
  DownloadURL,
  React
};